export default __webpack_public_path__ + "static/media/2411151.d8348563.jpg";